import { render, staticRenderFns } from "./ShareFilePatient.vue?vue&type=template&id=16e35a0a&scoped=true&"
import script from "./ShareFilePatient.vue?vue&type=script&lang=ts&"
export * from "./ShareFilePatient.vue?vue&type=script&lang=ts&"
import style0 from "./ShareFilePatient.vue?vue&type=style&index=0&id=16e35a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e35a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VPagination,VRow,VSpacer})
